// eslint-disable-next-line import/named
import { createRoute, redirect } from "@tanstack/react-router";

import { campaignRoute, campaignSearch } from "./campaignRoute";
import { askPunttProjectsRoute } from "./projectsRoute";

import { canAccessAskPuntt } from "../../utils/auth";
import { authLayoutRoute } from "../auth-layout/route";
import { ticketsRoute } from "../tickets/route";

function requireAskPuntt() {
  if (!canAccessAskPuntt()) {
    throw redirect({ to: ticketsRoute.to });
  }
}

/** Legacy `/ask-puntt/campaigns` → `/ask-puntt/projects`. */
export const askPunttCampaignsRedirectRoute = createRoute({
  getParentRoute: () => authLayoutRoute,
  path: "ask-puntt/campaigns",
  beforeLoad() {
    requireAskPuntt();
    throw redirect({ to: askPunttProjectsRoute.to });
  },
});

/** Legacy `/ask-puntt/campaigns/:projectId` → `/ask-puntt/projects/:projectId`. */
export const askPunttCampaignRedirectRoute = createRoute({
  getParentRoute: () => authLayoutRoute,
  path: "ask-puntt/campaigns/$projectId",
  beforeLoad: ({ params }) => {
    requireAskPuntt();
    throw redirect({
      to: campaignRoute.to,
      params: { projectId: params.projectId },
      search: campaignSearch(),
    });
  },
});
